import { ReduxActionType, Params } from 'types';
export interface NewMember {
  name: string;
  role: string;
  primaryContactEmail?: string;
  utilityId?: string;
  organisationType?: string;
}

export interface OrgTenant {
  id: number;
  name: string;
}
export interface CreateMemberRequest {
  member: NewMember;
  params?: any;
}
interface ActionType {
  FETCH_ADD_MEMBER_INIT: any;
  FETCH_ADD_MEMBER_REQUEST: any;
  FETCH_ADD_MEMBER_SUCCESS: ReduxActionType;
  FETCH_ADD_MEMBER_FAILURE: ReduxActionType;
  OPEN_ADD_MEMBER_MODAL_START: ReduxActionType;
  REMOVE_ERROR: ReduxActionType;
  UPDATE_NEW_RECORD_ADDED_FLAG: ReduxActionType;
}
interface EditActionType {
  FETCH_EDIT_MEMBER_INIT: any;
  FETCH_EDIT_MEMBER_REQUEST: any;
  FETCH_EDIT_MEMBER_SUCCESS: ReduxActionType;
  FETCH_EDIT_MEMBER_FAILURE: ReduxActionType;
  OPEN_EDIT_MEMBER_MODAL_START: ReduxActionType;
  REMOVE_ERROR: ReduxActionType;
}

interface OrgActionType {
  UPDATE_ORG_PROFILE_START: ReduxActionType;
  UPDATE_ORG_PROFILE_SUCCESS: ReduxActionType;
  UPDATE_ORG_PROFILE_FAILURE: ReduxActionType;
  FETCH_ORG_PROFILE_START: ReduxActionType;
  FETCH_ORG_PROFILE_SUCCESS: ReduxActionType;
  FETCH_ORG_PROFILE_FAILURE: ReduxActionType;
  CLEAR_ORG_PROFILE: ReduxActionType;
  UPDATE_ORG_PROFILE_UPDATE_FLAG: ReduxActionType;
  FETCH_ORG_TENANTS_START: ReduxActionType;
  FETCH_ORG_TENANTS_SUCCESS: ReduxActionType;
  FETCH_ORG_TENANTS_FAILURE: ReduxActionType;
}
export const AddMemberActionTypes: ActionType = {
  FETCH_ADD_MEMBER_INIT: '@@FETCH_ADD_MEMBER_INIT',
  FETCH_ADD_MEMBER_REQUEST: '@@FETCH_ADD_MEMBER_REQUEST',
  FETCH_ADD_MEMBER_SUCCESS: '@@FETCH_ADD_MEMBER_SUCCESS',
  FETCH_ADD_MEMBER_FAILURE: '@@FETCH_ADD_MEMBER_FAILURE',
  OPEN_ADD_MEMBER_MODAL_START: '@@OPEN_ADD_MEMBER_MODAL_START',
  REMOVE_ERROR: '@@REMOVE_ERROR',
  UPDATE_NEW_RECORD_ADDED_FLAG: '@@UPDATE_NEW_RECORD_ADDED_FLAG'
};

export const EditMemberActionTypes: EditActionType = {
  FETCH_EDIT_MEMBER_INIT: '@@FETCH_EDIT_MEMBER_INIT',
  FETCH_EDIT_MEMBER_REQUEST: '@@FETCH_EDIT_MEMBER_REQUEST',
  FETCH_EDIT_MEMBER_SUCCESS: '@@FETCH_EDIT_MEMBER_SUCCESS',
  FETCH_EDIT_MEMBER_FAILURE: '@@FETCH_EDIT_MEMBER_FAILURE',
  OPEN_EDIT_MEMBER_MODAL_START: '@@OPEN_EDIT_MEMBER_MODAL_START',
  REMOVE_ERROR: '@@REMOVE_ERROR'
};

export const OrganisationActionTypes: OrgActionType = {
  UPDATE_ORG_PROFILE_START: '@@UPDATE_ORG_PROFILE_START',
  UPDATE_ORG_PROFILE_SUCCESS: '@@UPDATE_ORG_PROFILE_SUCCESS',
  UPDATE_ORG_PROFILE_FAILURE: '@@UPDATE_ORG_PROFILE_FAILURE',
  FETCH_ORG_PROFILE_START: '@@FETCH_ORG_PROFILE_START',
  FETCH_ORG_PROFILE_SUCCESS: '@@FETCH_ORG_PROFILE_SUCCESS',
  FETCH_ORG_PROFILE_FAILURE: '@@FETCH_ORG_PROFILE_FAILURE',
  CLEAR_ORG_PROFILE: '@@CLEAR_ORG_PROFILE',
  UPDATE_ORG_PROFILE_UPDATE_FLAG: '@@UPDATE_ORG_PROFILE_UPDATE_FLAG',
  FETCH_ORG_TENANTS_START: '@@FETCH_ORG_TENANTS_START',
  FETCH_ORG_TENANTS_SUCCESS: '@@FETCH_ORG_TENANTS_SUCCESS',
  FETCH_ORG_TENANTS_FAILURE: '@@FETCH_ORG_TENANTS_FAILURE'
};

export interface MemberState {
  submitting: boolean;
  fetchingOrgProfile: boolean;
  error?: string;
  data?: string;
  orgProfile: any;
  orgProfileUpdated?: boolean;
  isModalOpen?: boolean;
  isNewRecordAdded?: boolean;
  orgTenants?: OrgTenant[];
  gettingOrgTenants?: boolean;
  type?: 'ADD' | 'EDIT'; //Default is ADD
}
export interface OrganisationProfileDataTypes {
  contactName?: string;
  contactEmail?: string;
  contactPhoneNumber?: string;
  contactEmergencyPhone?: string;
  contactUrl?: string;
  isDisabled?: boolean;
  aoiBuffer?: number;
}

export interface FetchOrgProfileParams {
  organisationId: number;
  params: Params;
}

export interface UpdateOrgProfileParams {
  organisationId: number;
  payload: OrganisationProfileDataTypes;
  params?: Params;
  refreshMembersList?: boolean;
}
export interface Header {
  key: string;
  header: string;
  isSortable?: boolean;
}
